import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconLeftArrow: React.FC<IconProps> = ({ color = 'black', width = 8, height = 14 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 8 14"
            fill="none"
        >
            <path
                d="M1 13L7 7L1 1"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default IconLeftArrow;
